import React from 'react'

import { Box, Typography } from '@material-ui/core'

import useLineSummary from './useLineSummary'

import { NewLineSummaryProps, PortabilityLineSummaryProps } from '../../model/line.model'

import ModifyButton from '~/ui/components/ModifyButton/ModifyButton'

function NewLineSummary({
  id,
  newLineValues: { signUpTypeLiteral, numberLiteral, linePhoneNumber },
}: NewLineSummaryProps) {
  return (
    <Box mt={5} mb={4} display="flex" flexDirection="row" alignItems="baseline">
      <Box display="flex" flexDirection="row" alignItems="baseline">
        <Typography variant="body2">Tipo de alta: </Typography>
        <Box ml={1}>
          <Typography variant="subtitle2" data-hook={`${id}.signupType`}>
            {signUpTypeLiteral}
          </Typography>
        </Box>
      </Box>
      <Box display="flex" flexDirection="row" alignItems="baseline" ml={8}>
        <Typography variant="body2">{numberLiteral}: </Typography>
        <Box ml={1}>
          <Typography variant="subtitle2" data-hook={`${id}.lineNumber`}>
            {linePhoneNumber}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}

function PortabilityLineSummary({
  id,
  portabilityValues: {
    signUpTypeLiteral,
    numberLiteral,
    linePhoneNumber,
    portabilityTypeLiteral,
    ownerName,
    isSameDonor,
    donorDocId,
  },
}: PortabilityLineSummaryProps) {
  return (
    <>
      <Box mt={5} mb={4} display="flex" flexDirection="row" alignItems="baseline">
        <Box display="flex" flexDirection="row" alignItems="baseline">
          <Typography variant="body2">Tipo de alta: </Typography>
          <Box ml={1}>
            <Typography variant="subtitle2" data-hook={`${id}.signupType`}>
              {signUpTypeLiteral}
            </Typography>
          </Box>
        </Box>
        <Box display="flex" flexDirection="row" alignItems="baseline" ml={8}>
          <Typography variant="body2">{numberLiteral}: </Typography>
          <Box ml={1}>
            <Typography variant="subtitle2" data-hook={`${id}.lineNumber`}>
              {linePhoneNumber}
            </Typography>
          </Box>
        </Box>
        <Box display="flex" flexDirection="row" alignItems="baseline" ml={8}>
          <Typography variant="body2">Tipo de portabilidad: </Typography>
          <Box ml={1}>
            <Typography variant="subtitle2" data-hook={`${id}.portaType`}>
              {portabilityTypeLiteral}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box mt={5} mb={4} display="flex" flexDirection="row" alignItems="baseline">
        <Box display="flex" flexDirection="row" alignItems="baseline">
          <Typography variant="body2">Titular de la portabilidad: </Typography>
          <Box ml={1}>
            <Typography variant="subtitle2" data-hook={`${id}.lineOwner`}>
              {ownerName}
            </Typography>
          </Box>
        </Box>
        {!isSameDonor && (
          <Box display="flex" flexDirection="row" alignItems="baseline" ml={8}>
            <Typography variant="body2">Documento: </Typography>
            <Box ml={1}>
              <Typography variant="subtitle2">{donorDocId}</Typography>
            </Box>
          </Box>
        )}
      </Box>
    </>
  )
}

export default function LineSummary({ id }: { id: string }) {
  const { isNewLine, newLineValues, portabilityValues } = useLineSummary(id)

  return (
    <Box>
      <Typography variant="subtitle1">DATOS DE LA LÍNEA</Typography>
      {isNewLine ? (
        <NewLineSummary newLineValues={newLineValues} id={id} />
      ) : (
        <PortabilityLineSummary portabilityValues={portabilityValues} id={id} />
      )}
      <ModifyButton text="Modificar información de la línea" />
    </Box>
  )
}
